<template>
    <div class="font_Montserrat v3_color_black_knight study-header">
        <!-- Section progress bar -->
        <b-row>
            <b-col md="6" sm="12">
                <p class="v2_font_weight_bold font_size_1500rem">
                    {{ pageTitle }}
                </p>
            </b-col>
            <b-col md="6" sm="12">
                <div v-if="question">
                    <section-progress-bar :sections="sections" :question="question"/>
                </div>
            </b-col>
        </b-row>
        <div class="study-form-container">
            <b-container class="survey-form pt-3">
                <v-wait :for="loaderId">
                    <HalfCircleSpinner slot="waiting"/>
                    <template slot="waiting">
                        <div class="spinner-message my-3 text-center">Loading...</div>
                    </template>
                    <b-row>
                        <b-col
                                :md="
                isQuestionnaireSupportJobPreferences && !isModuleQuestionnaire
                  ? 8
                  : 12
              "
                                class="order-1"
                        >
                            <div class="survey-form__body" v-cloak>
                                <!-- question body -->
                                <QuestionForm
                                        v-if="question && question.type !== 'GEOGRAPHY_ICO_WRAPPER'"
                                        ref="questionForm"
                                        :key="question.id"
                                        :survey="survey"
                                        :question="question"
                                        :variables="variables"
                                        :is-last-question="isLastQuestion"
                                        :all-questions="questions"
                                        :is-support-job-preferences="
                    isQuestionnaireSupportJobPreference
                  "
                                        :disabled="survey.submitted && !isModuleQuestionnaire"
                                        @question-form-change="onStudyQuestionUpdated"
                                        @go-to-question="onSelectQuestion"
                                        @set-is-completed="handleSetCurrentQuestionIsComplete"
                                >
                                    <div v-if="isJobQuestionShown && !hasPriorYearQuestionnaireId" ref="isoStudyQuestion">
                                        <ico-study-question
                                                ref="icoStudyQuestion"
                                                :initial-job-question="question.relatedJobQuestion"
                                                :study-question="question"
                                                :default-job-profile="defaultJobProfile"
                                                @job-question-updated="onJobQuestionUpdated"
                                        />
                                    </div>
                                </QuestionForm>
                                <div
                                        v-else-if="
                    question && question.type === 'GEOGRAPHY_ICO_WRAPPER'
                  "
                                        ref="isoStudyQuestion"
                                >
                                    <ico-study-question
                                            ref="icoStudyQuestion"
                                            :initial-job-question="question.relatedJobQuestion"
                                            :study-question="question"
                                            :default-job-profile="defaultJobProfile"
                                            @update-job-profile="onUpdateJobProfile"
                                    />
                                </div>
                            </div>
                        </b-col>
                        <b-col
                                v-if="
                isQuestionnaireSupportJobPreferences && !isModuleQuestionnaire && !hasPriorYearQuestionnaireId
              "
                                md="4"
                                class="order-3 order-md-2 mt-3 mt-md-0 d-none d-md-block"
                        >
                            <my-desired-job-profile-section>
                                <desired-job-question
                                        v-for="(jQ, index) in getJobQuestions()"
                                        :key="`djq_${jQ.id}_${index}`"
                                        :job-question="jQ"
                                        :is-selected="currentJobQuestionId === jQ.id"
                                        @select-on-div="onSelectJobQuestionInMyDesiredSection(jQ.id)"
                                >
                  <span slot="right-section" class="select-icon-wrapper">
                    <p class="clickable" style="font-size: 0.875rem">
                      <i class="mdi mdi-pencil clickable"/>
                      &nbsp;&nbsp; Edit Section
                    </p>
                  </span>
                                </desired-job-question>
                            </my-desired-job-profile-section>
                        </b-col>
                    </b-row>
                    <b-modal
                            size="xl"
                            centered
                            hide-footer
                            header-class="job-profile-summary-header justify-content-start"
                            body-class="v2_font_size_18"
                            no-close-on-backdrop
                            no-close-on-esc
                            :visible="isSubmitModalVisible"
                            :hide-header-close="survey.submitted && isModuleQuestionnaire"
                    >
                        <template
                                v-if="
                isQuestionnaireSupportJobPreference && !isModuleQuestionnaire
              "
                        >
                            <template slot="modal-header-close">
                                <div>
                                </div>
                            </template>
                            <fragment v-if="!survey.submitted && !hasPriorYearQuestionnaireId">
                                <b-row class="mt-2 submitted-survey-container">
                                    <b-col cols="12">
                                        <div
                                                v-if="content && content.header"
                                                v-html="content.header"
                                        />
                                        <b v-else>
                                            Thank you for completing a Phyisician Value Study.
                                        </b>
                                        <template v-if="content && content.body">
                                            <div v-html="content.body"/>
                                        </template>
                                        <template v-else>
                                            <p class="mt-2">
                                                You have completed your Physician Value Study and
                                                developed your first Ideal Career Opportunity (ICO)
                                                profile.
                                            </p>
                                            <p>
                                                You will likely create more than one ICO, so name it
                                                with something specific (e.g., ‘max_comp’ or
                                                ‘Northeast_$375k’).
                                            </p>
                                        </template>
                                        <p style="color: #00586f; margin-bottom: 5px">
                                            NAME ICO:
                                            <b-form-input
                                                    :placeholder="'My Job Preferences'"
                                                    v-model="$v.title.$model"
                                                    @focus="$event.target.select()"
                                                    :state="validateState('title')"
                                                    aria-describedby="input-feedback"
                                            />
                                            <b-form-invalid-feedback id="input-feedback">
                                                This field is required
                                            </b-form-invalid-feedback>
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <div class="button-container">
                                        <b-col cols="12" class="d-flex py-3">
                                            <b-button
                                                    class="mx-3"
                                                    variant="v3_red_outline"
                                                    :disabled="submitLoading"
                                                    @click="isSubmitModalVisible = false"
                                            >
                                                Cancel
                                            </b-button>
                                            <b-button
                                                    class="mx-3 submit-button"
                                                    variant="v3_teal_outline"
                                                    :disabled="submitLoading"
                                                    @click="onSubmitSurvey(true)"
                                            >
                                                <b-spinner small v-if="submitLoading"/>
                                                <span v-else>Submit</span>
                                            </b-button>
                                        </b-col>
                                    </div>
                                </b-row>
                            </fragment>
                            <fragment v-else-if="!survey.submitted && hasPriorYearQuestionnaireId">
                                <b-row class="mt-2 submitted-survey-container">
                                    <b-col cols="12">
                                        <b>
                                            Thank you. We’ve updated your responses and they are now included in the {{ specialtyName }} Study. You can now know your current professional value.
                                        </b>
                                        <template>
                                            <p class="mt-2">
                                                You’re almost done. Let’s update how you receive your professional value. Your ICOs allow employers and recruiters to offer you the jobs you want on your terms – anonymously. Have your career goals or requirements changed since last year?
                                            </p>
                                        </template>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" class="d-flex py-3 w-100">
                                        <!-- <b-button
                                                class="mx-3"
                                                variant="v3_red_outline"
                                                :disabled="submitLoading"
                                                @click="isSubmitModalVisible = false"
                                        >
                                            Cancel
                                        </b-button> -->
                                        <b-button
                                                class="mx-3 submit-button review-ico-btn"
                                                variant="v3_teal_outline"
                                                @click="reviewICOHandler"
                                        >
                                            <b-spinner small v-if="submitLoading"/>
                                            <span v-else>Review ICO</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </fragment>
                            <fragment v-else>
                                <b-row class="submitted-survey-container">
                                    <b-col cols="12" lg="6" offset-lg="3" class="text-center">
                                        <!--                    <i class="mdi-text-box-check-outline" style="color: #c2d500"/>-->
                                        <!--                    <br>-->
                                        <b>Where to now?</b>
                                        <br/><br/>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" lg="12" class="text-center">
                                        Review specialty data
                                        <br />
                                        <div class="d-flex justify-content-center pt-2">
                                            <b-button
                                                class="mx-3 go-to-inform-connect-button"
                                                variant="v3_teal_outline"
                                                :to="
                                                    isModuleQuestionnaire
                                                    ? `/user/filters/${survey.questionnaire_id}/${this.$route.params.sectionId}`
                                                    : `/user/filters/${survey.questionnaire_id}`
                                                "
                                            >
                                                Go to Inform
                                            </b-button>
                                        </div>
                                        <br /><br />
                                        Create another ICO
                                        <div class="d-flex justify-content-center pt-2">
                                            <b-button
                                                class="mx-3 go-to-inform-connect-button"
                                                variant="v3_teal_outline"
                                                to="/user/exchange"
                                            >
                                                Go to Connect
                                            </b-button>
                                        </div>
                                        <br /> <br />
                                        Complete any optional study modules to access additional specialty data.
                                        <div class="d-flex justify-content-center pt-2">
                                            <b-button
                                                class="mx-3 go-to-inform-connect-button"
                                                variant="v3_teal_outline"
                                                to="/surveyHome"
                                            >
                                                Go to Share
                                            </b-button>
                                        </div>
                                        <br /> <br />
                                    </b-col>
                                </b-row>
                            </fragment>
                        </template>
                        <template v-else>
                            <fragment v-if="!survey.submitted">
                                <b-row>
                                    <b-col cols="12">
                                        <p>Well done! You have completed your Study.</p>
                                        <p>
                                            Once you are satisfied with your Study answers hit the
                                            “Submit” button.
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" class="d-flex justify-content-center py-3">
                                        <b-button
                                                class="mx-3"
                                                variant="v3_teal_outline"
                                                :disabled="submitLoading"
                                                @click="onSubmitSurvey(false)"
                                        >
                                            <b-spinner small v-if="submitLoading"/>
                                            <span v-else>Submit</span>
                                        </b-button>
                                        <b-button
                                                class="mx-3"
                                                variant="v3_red_outline"
                                                :disabled="submitLoading"
                                                @click="isSubmitModalVisible = false"
                                        >
                                            Cancel
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </fragment>
                            <fragment v-else>
                                <b-row>
                                    <b-col cols="12" class="text-center">
                                        <p>
                                          {{ isModuleQuestionnaire ? 'You have submitted your Module. You may now review these data fields in Inform, complete another Module in Share, or return to your Dashboard. If you indicated interest in learning more about the topic covered in this Module, Phairify will notify you on your Dashboard when your colleagues have provided sufficient data to answer your questions.' : '' }}
                                          {{ isModuleQuestionnaire ? '' : 'You have submitted your Study. You may now review these data fields in Inform, complete a Module in Share if one exists, or return to your Dashboard.'  }}
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" lg="6" offset-lg="3" class="d-flex justify-content-center flex-column py-3">
                                        <b-button
                                            variant="v3_teal_outline"
                                            class="mb-3"
                                            :to="isModuleQuestionnaire
                                                ? `/user/filters/${survey.questionnaire_id}/${this.$route.params.sectionId}`
                                                : `/user/filters/${survey.questionnaire_id}`
                                            "
                                        >
                                            Go to Inform
                                        </b-button>
                                        <b-button
                                            variant="v3_teal_outline"
                                            class="mb-3"
                                            to="/user/surveyHome"
                                        >
                                            Go to Share
                                        </b-button>
                                        <b-button
                                            variant="v3_teal_outline"
                                            class="mb-3"
                                            to="/user/dashboard"
                                        >
                                            Go to Dashboard
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </fragment>
                        </template>
                    </b-modal>

                    <!----- Review ICO Modal Start ----->
                    <b-modal
                        size="xl"
                        centered
                        hide-footer
                        header-class="job-profile-summary-header justify-content-start"
                        body-class="v2_font_size_18"
                        no-close-on-backdrop
                        no-close-on-esc
                        :visible="isReviewIcoModalVisible"
                        :hide-header-close="survey.submitted && isModuleQuestionnaire"
                >
                            <template
                                    v-if="
                            isQuestionnaireSupportJobPreference && !isModuleQuestionnaire
                            ">
                            <template slot="modal-header-close"><div></div></template>
                            <fragment v-if="!survey.submitted && hasPriorYearQuestionnaireId">
                                <b-row class="mt-2 submitted-survey-container">
                                    <b-col cols="12">
                                        <template>
                                            <p class="mt-2">
                                                You’ve asked Phairify to keep an eye out for job opportunities matching 
                                                the specific terms of your ICO, below. Take a moment to confirm, edit, 
                                                or replace this ICO to make sure we’re promoting to the market 
                                                the exact job terms you want to hear about.
                                            </p>
                                        </template>
                                    </b-col>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-col
                                    v-if="this.prior_survey"
                                    cols="12" class="d-flex py-2 flex-flow-column">
                                            <desired-prior-job-question
                                                    v-for="(jQ, index) in getPriorQuestionnaireJobQuestions()"
                                                    :key="`djq_${jQ.id}_${index}`"
                                                    :job-question="jQ"
                                            >
                                            <span slot="right-section" class="select-icon-wrapper">
                                                <p class="clickable" style="font-size: 0.875rem">
                                                </p>
                                            </span>
                                            </desired-prior-job-question>
                                    </b-col>
                                    <!-- <b-col cols="8" class="d-flex py-2">
                                        <table class="table">
                                            <template>
                                                <tbody>
                                                    <tr>
                                                        <td>Location</td>
                                                        <td>{{ this.getDesiredLocationDisplayName() }}</td>
                                                    </tr>
                                                    <template  v-if="this.loadDefaultSurveyData()">
                                                    <tr v-for="que in this.loadDefaultSurveyData()" :key="que.question.id">
                                                        <template  v-if="que.question.job_question_id"> 
                                                            <td>{{ que.question.label }}</td>
                                                            <td v-if="que.question.relatedJobQuestion != null">
                                                                <template v-if="que.question.type=='SLIDER'">
                                                                    {{ (que.question.relatedJobQuestion) ? `${que.question.firstVariable.prefix ? que.question.firstVariable.prefix : ''} ${formatValue(que.question.relatedJobQuestion.response_default_value)}` : '' }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ (que.question.relatedJobQuestion) ? `${que.question.firstVariable.prefix ? que.question.firstVariable.prefix : ''}  ${que.question.relatedJobQuestion.response_default_value}` : '' }}
                                                                </template>
                                                            </td>
                                                        </template>
                                                    </tr>
                                                    </template>
                                                </tbody>
                                            </template>
                                        </table>
                                    </b-col> -->
                                </b-row>
                                <b-row>
                                    <b-col cols="12" class="d-flex py-2">
                                        <b-button
                                                class="mx-3 review-ico-btn"
                                                variant="v3_teal_outline"
                                                @click="goToDashBoard"
                                        >
                                                I still want this job
                                        </b-button>
                                        </b-col>
                                        <b-col cols="12" class="d-flex py-2">
                                                <b-button
                                                        class="mx-3 submit-button review-ico-btn"
                                                        variant="v3_teal_outline"
                                                        @click="icoInEditMode"
                                                >
                                                I want this job but with some changes
                                                </b-button>
                                        </b-col>
                                        <b-col cols="12" class="d-flex py-2">
                                                <b-button
                                                        class="mx-3 submit-button review-ico-btn"
                                                        variant="v3_teal_outline"
                                                        @click="createNewIcoMode"
                                                >
                                                My goals have changed – I want another job
                                                </b-button>
                                        </b-col>
                                </b-row>
                            </fragment>
                            </template>
                    </b-modal>
                    <!----- Review ICO Modal End ----->
                    <!----- New ICO Modal Start ----->
                    <b-modal
                        size="xl"
                        centered
                        hide-footer
                        header-class="job-profile-summary-header justify-content-start"
                        body-class="v2_font_size_18"
                        no-close-on-backdrop
                        no-close-on-esc
                        :visible="isNewIcoModalVisible"
                        :hide-header-close="survey.submitted && isModuleQuestionnaire"
                >
                            <template
                                    v-if="
                            isQuestionnaireSupportJobPreference && !isModuleQuestionnaire
                            ">
                            <template slot="modal-header-close"><div></div></template>
                            <fragment v-if="!survey.submitted && hasPriorYearQuestionnaireId">
                                <b-row class="mt-2 submitted-survey-container">
                                    <b-col cols="12">
                                        <job-profile-title-intial-card            
                                            @cancel="onCancelNewJobProfile"            
                                            @form-submit="onRenameJobProfile"
                                        />
                                    </b-col>
                                </b-row>
                            </fragment>
                            </template>
                    </b-modal>
                    <!----- New ICO Modal Start ----->
                </v-wait>
            </b-container>
        </div>
        
        <study-progress-bar
                :class="[
        'study-progress-bar',
        { 'with-arrow': !isJobQuestionFullyOnScreen },
      ]"
                :survey="survey"
                :questions="questions"
                :variables="variables"
                :is-last-question="isLastQuestion"
                :submit-loading="submitLoading"
                :curr-question-id="parseInt((this.question || {}).id)"
                :is-curr-question-interested="parseInt((this.question || {}).is_have_interested_question)"
                :is-submit-disabled="isCompleteButtonDisabled"
                :is-module-questionnaire="isModuleQuestionnaire"
                @go-to-previous="previousQuestion"
                @go-to-next="onNextHandle"
                @complete-study="completeStudyHandler"
                @go-to-question="onSelectQuestion"
        />
        <span
                v-if="this.question && this.question.type === 'SLIDER'"
                :set="(invalid = isInvalid(question))"
        >
      <slider-not-answered-modal
              v-model="isSliderNotAnsweredModalVisible"
              :question="question"
              :variables="variables"
              :reset-min-disabled="invalid"
              @close="isSliderNotAnsweredModalVisible = false"
              @answer-later="onAnswerQuestionLater"
              @reset-to-min="onResetSliderToMin"
      >
        <span slot="modal-msg" v-if="invalid">
          You have not selected a value for this question. Would you like to go
          back and select a value or answer the question later?
        </span>
      </slider-not-answered-modal>
    </span>
        <b-modal
                size="xl"
                centered
                hide-footer
                header-class="job-profile-summary-header justify-content-start"
                body-class="v2_font_size_18"
                no-close-on-backdrop
                no-close-on-esc
                :visible="showRemindIcoQuestionModal"
                @close="scrollToICOQuestion"
        >
            <template>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="p-3">
                        Please answer the Ideal Career Opportunity question, below, before proceeding to the next question.
                        This input will help your understanding of the market for your specialty.
                    </p>
                    <b-button
                            variant="v3_red_outline"
                            class="mt-3 ml-3"
                            @click="scrollToICOQuestion"
                    >
                        Cancel
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal
                size="xl"
                centered
                hide-footer
                header-class="job-profile-summary-header justify-content-start"
                body-class="v2_font_size_18"
                no-close-on-backdrop
                no-close-on-esc
                :visible="showRemindCoreQuestionModal"
                @close="showRemindCoreQuestionModal = false"
        >
            <template>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="p-3">
                        You have not selected a value for this question. Would you like to go
                        back and select a value or answer the question later?
                    </p>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                    
                    <b-button
                        variant="v2_primary"
                        class="mb-2 mb-lg-0 mr-3"
                        @click="showRemindCoreQuestionModal = false"
                    >
                        Return to Question
                    </b-button>
                    <b-button
                        variant="v2_primary"
                        class="mb-2 mb-lg-0"
                        @click="onAnswerCoreQuestionLater"
                    >
                        Answer Question Later
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<!-- -------------------------------------------------------- -->

<script>
import Api, {didAbort} from '@/providers/Api.js';
import QuestionForm from '@/components/QuestionForm.vue';
import {
    GET_SURVEY_ACTION,
    QUESTION_TYPES,
    SET_USER_DEFAULT_JOB_PROFILE_MUTATION,
} from '@/store';
import {HalfCircleSpinner} from 'epic-spinners';
import findLastIndex from 'lodash/findLastIndex';
import {
    getSectionApplicableCount,
    getSectionCompletedOrDeclinedCount,
    incompletedQuestions,
    isApplicableQuestion,
    isCompleted,
    isIcoCompleted,
    isDeclined,
    isInvalid,
    isVariableHasNoResponse,
} from '@/helpers/questionnaireHelper';
import {createGeographyQuestionObjectFromJobProfile} from '@/helpers/jobQuestionsHelper';
import {UPDATE_JOB_PROFILE_ACTION} from '@/store/jobProfiles';
import showResponseErrorsMixin from '@/mixins/showResponseErrorsMixin';
import MyDesiredJobProfileSection from '@/components/study/form/desired-job-profile/MyDesiredJobProfileSection';
import DesiredPriorJobQuestion from '@/components/study/form/desired-job-profile/DesiredPriorJobQuestion';
import {validationMixin} from 'vuelidate';
import GetMembershipTypeOptionsMixin from '@/mixins/GetMembershipTypeOptionsMixin';
import DerivedVariables from '@/providers/DerivedVariables';
import {handleServerErrorWithValidation} from '@/helpers/ToastedHelper';
import StudyProgressBar from '@/components/study/form/progress-bar/StudyProgressBar';
import IcoStudyQuestion from '@/components/study/form/ico-question/IcoStudyQuestion';
import DesiredJobQuestion from '@/components/study/form/desired-job-profile/DesiredJobQuestion';
import SectionProgressBar from '@/components/study/form/section-progress-bar/SectionProgressBar';
import Help from '@/providers/Help';
import SliderNotAnsweredModal from '@/components/study/form/SliderNotAnsweredModal';
import {required} from 'vuelidate/lib/validators';
import JobProfileTitleIntialCard from '@/components/exchange/job-profile-details/JobProfileTitleIntialCard';
//import conditionVariables from '@/store/conditionVariables';

const modifiedConfirmMessage =
    'Changes made to the current question will not be saved. Are you sure you want to leave this page?';

const notCompletedQuestionaire = 
    'You have not completed your study and data may be lost. Are you sure you want to leave this page?';

const activityEvents = [
    'mousedown',
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
];

export default {
    name: 'StudyForm',
    mixins: [
        validationMixin,
        showResponseErrorsMixin,
        GetMembershipTypeOptionsMixin,
    ],
    components: {
        QuestionForm,
        HalfCircleSpinner,
        MyDesiredJobProfileSection,
        StudyProgressBar,
        IcoStudyQuestion,
        DesiredJobQuestion,
        SectionProgressBar,
        SliderNotAnsweredModal,
        JobProfileTitleIntialCard,
        DesiredPriorJobQuestion
    },
    data: function () {
        return {
            survey: {},
            submitLoading: false,
            geographicJobQuestion: null,
            isCompleteClicked: false,
            isJobQuestionFullyOnScreen: true,
            isCurrentQuestionComplete: false,
            isSubmitModalVisible: false,
            isSliderNotAnsweredModalVisible: false,
            currentQuestionIndex: false,
            sectionActionLabel: 'Edit Section',
            content: null,
            title: null,
            isIcoQuestionAnswered: false,
            showRemindIcoQuestionModal: false,
            showRemindCoreQuestionModal: false,
            completeSurveFlag: false,
            priorSurvey: null,
            prior_year_questionnaire_id:null,
            isReviewIcoModalVisible: false,
            isNewIcoModalVisible: false,
            getDefaultQuestionResponse: [],
            prior_survey: null,
            isFirstTime: true
        };
    },
    lastActivityTime: true,
    takingStudyInterval: null,
    takingStudyIntervalValue: 15000, // 15000ms = 15s
    afterSliderNotAnsweredIsClosed: null,
    afterCoreQuestionNotAnsweredIsClosed: null,
    validations: {
        questionForm: {},
        title: {
            required,
        },
    },
    created: function () {
        // this.survey = Survey.loadSurvey(this.$route.params.surveyId)
        this.loadSurvey();
        this.geographicJobQuestion = createGeographyQuestionObjectFromJobProfile(
            this.defaultJobProfile
        );
        this.getContent();
    },
    beforeMount: function () {
        window.addEventListener('beforeunload', this.preventEventIfDirtyOrErrors);
    },
    mounted: function () {
        document.addEventListener('scroll', this.calculateIsJobQuestionVisible);
        this.$nextTick(() => {
            this.calculateIsJobQuestionVisible();
        });

        if(this.prior_year_questionnaire_id && this.$store.state.setPriorSurvey){
            this.fetchPriorData();
        }
        //add these events to the document.
        //register the activity function as the listener parameter.
        activityEvents.forEach((eventName) => {
            document.addEventListener(
                eventName,
                this.updateUserLastActivityTime,
                true
            );
        });
    },
    beforeDestroy: function () {
        document.removeEventListener('scroll', this.calculateIsJobQuestionVisible);
        window.removeEventListener(
            'beforeunload',
            this.preventEventIfDirtyOrErrors
        );
        clearInterval(this.$options.takingStudyInterval);
        activityEvents.forEach((eventName) => {
            document.removeEventListener(
                eventName,
                this.updateUserLastActivityTime,
                true
            );
        });
    },
    beforeRouteLeave: function (to, from, next) {
        if (this.$v.questionForm.$anyDirty)
            return Help.confirm.show(
                modifiedConfirmMessage,
                'Leave',
                () => {
                    next();
                },
                () => {
                    next(false);
                }
            );

        if (this.isCompleteButtonDisabled && !this.isAllQuestionsCompleted && !this.completeSurveFlag)
            return Help.confirm.show(
                notCompletedQuestionaire,
                'Leave',
                () => {
                    next();
                },
                () => {
                    next(false);
                }
            );
        return next();
    },
    computed: {
        isQuestionnaireSupportJobPreferences: function () {
            return (
                this.survey.questionnaire &&
                this.survey.questionnaire.is_support_job_preference
            );
        },
        loaderId: function () {
            return `loading_${this.$options.name}`;
        },
        question: function () {
            return this.survey ? this.questions[this.currentQuestionIndex] : null;
        },
        pageTitle: function () {
            const questionnaire = (this.survey || {}).questionnaire;
            return questionnaire
                ? `${questionnaire.period} ${questionnaire.title}`
                : '';
        },
        isLastQuestion: function () {
            return this.questions
                ? this.currentQuestionIndex >= this.questions.length - 1 &&
                this.isJobQuestionAnswered()
                : false;
        },
        incompletedQuestions: function () {
            return incompletedQuestions(
                this.questions,
                this.variables,
                this.isQuestionnaireSupportJobPreferences
            );
        },
        isQuestionnaireSupportJobPreference: function () {
            return !!(
                this.survey.questionnaire &&
                this.survey.questionnaire.is_support_job_preference
            );
        },
        isJobQuestionShown: function () {
            return (
                (this.isQuestionnaireSupportJobPreference &&
                !!this.question.relatedJobQuestion)
            );
        },
        hasPriorYearQuestionnaireId: function () {
            if(this.$store.state.setPriorSurvey){
                return true;
            }else{
                return false;
            }
            //return this.prior_year_questionnaire_id ? true : false;
        },
        defaultJobProfile: {
            get: function () {
                return this.$store.getters.userDefaultJobProfile;
            },
            set: function (data) {
                this.$store.commit(SET_USER_DEFAULT_JOB_PROFILE_MUTATION, data);
            },
        },
        membershipSupportedFields: function () {
            return this.$store.getters.getMembershipTypesSupportedFields(
                this.user.society_membership_type_id
            );
        },
        user: function () {
            return this.$store.state.user || {};
        },
        specialtyName: function () {
            return (this.user.specialty || {}).title;
        },
        sections: function () {
            if (!this.survey || !this.survey.questionnaire) return [];
            return this.survey.questionnaire.sections;
        },
        questions: function () {
            // const surveyQuestions = this.sections.flatMap((s) =>
            //     Array.isArray(s.questionSections) &&
            //     (this.isModuleQuestionnaire || !s.is_module)
            //         ? s.questionSections.map((qs) => qs.question)
            //         : []
            // );

            const surveyQuestions = [];
            this.sections.forEach((s) => {
                if (Array.isArray(s.questionSections) && (this.isModuleQuestionnaire || !s.is_module)) {
                    s.questionSections.forEach((qs,index) => {
                        if(s.is_have_interested_question == 1){
                            if (index === s.questionSections.length - 1) {
                                qs.question.is_have_interested_question = 1;
                            }else{
                            qs.question.is_have_interested_question = 0;  
                        }
                        }else{
                            qs.question.is_have_interested_question = 0;  
                        }
                        surveyQuestions.push(qs.question);
                    });
                }
            });

            if (
                this.isQuestionnaireSupportJobPreference &&
                !this.$route.params.sectionId && !this.hasPriorYearQuestionnaireId
            ) {
                return [
                    ...surveyQuestions,
                    {
                        id: Date.now(),
                        type: QUESTION_TYPES.GEOGRAPHY_ICO_WRAPPER,
                        variables: [],
                        relatedJobQuestion: this.geographicJobQuestion,
                    },
                ];
            }
            return surveyQuestions;
        },
        variables: function () {
            return this.questions.flatMap((q) =>
                Array.isArray(q.variables) ? q.variables.map((v) => v) : []
            );
        },
        currentJobQuestionId: function () {
            return this.question && this.question.relatedJobQuestion
                ? this.question.relatedJobQuestion.id
                : null;
        },
        isOnlyCurrentQuestionUncompleted: function () {
            return (
                this.numberOfUncompletedQuestions === 1 &&
                this.incompletedQuestions.some(({id}) => id === this.question.id)
            );
        },
        numberOfUncompletedQuestions: function () {
            return this.incompletedQuestions.length;
        },
        isCompleteButtonDisabled: function () {
            return (
                !this.isCurrentQuestionComplete ||
                (!this.isAllQuestionsCompleted &&
                    (!this.isOnlyCurrentQuestionUncompleted ||
                        (!this.$v.$anyDirty &&
                            this.question.type !== QUESTION_TYPES.SLIDER &&
                            this.question.type !== QUESTION_TYPES.GEOGRAPHY_ICO_WRAPPER))) ||
                (!!this.survey.submitted && !this.isModuleQuestionnaire)
            );
        },
        isAllQuestionsCompleted: function () {
            return this.numberOfUncompletedQuestions === 0;
        },
        isModuleQuestionnaire: function () {
            return this.$route.params.sectionId;
        },
    },
    methods: {
        async fetchPriorData() {
            try {
                if (this.prior_year_questionnaire_id !== null && this.$store.state.setPriorSurvey) {
                    await this.loadPriorSurvey();
                }
                // Continue with your other code...
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        formatValue(value) {
            const nf = new Intl.NumberFormat('en-US');
            return nf.format(Math.floor(value));
        },
        loadSurvey: async function () {
            const {surveyId, sectionId = null} = this.$route.params;

            let surveyData = null;
            if(!this.$store.state.changeResponseQuestionIds){
                surveyData = !sectionId
                ? this.$store.getters.getSurveyData(surveyId)
                : null; 
            }
            if (!surveyData) {
                this.$wait.start(this.loaderId);
                try {
                    surveyData = await this.$store.dispatch(GET_SURVEY_ACTION, {
                        surveyId,
                        sectionId,
                    });
                } catch (error) {
                    this.$wait.end(this.loaderId);
                    process.env.NODE_ENV !== 'production' && console.error(error);
                    this.$toasted.show('Some error occurs', {
                        type: 'error',
                        duration: 3000,
                    });
                }
            }
            const {survey} = surveyData || {};

            if (survey.submitted && !sectionId) {
                this.$router.push({name: 'studies'});
            }

            this.survey = survey;
            this.prior_year_questionnaire_id = this.survey.questionnaire ? this.survey.questionnaire.prior_year_questionnaire_id : null;
            if(this.$store.state.changeResponseQuestionIds && this.$store.state.changeResponseQuestionIds.length > 0){
                this.setPriorQuestionnaire();
            }
            // if(this.prior_year_questionnaire_id){
            //     this.loadPriorSurvey();
            // }
            this.$nextTick(() => {
                this.calculateIsSurveyComplete();
                this.calculateCurrentQuestionIndex();
                this.initTakingStudyTimeCounter();
            });
            this.$wait.end(this.loaderId);
        },
        loadPriorSurvey: async function () {
            if(this.prior_year_questionnaire_id){
                try {
                    const prior_survey_data = await Api.getSurveyDetailsByQuestionnaireidAndUserid(
                    this.user.id,this.prior_year_questionnaire_id
                    );
                    if(!prior_survey_data){
                        return null;
                    }
                    const surveyId = prior_survey_data.id;
                    const sectionId = null;

                    let surveyData = null;
                    if (!surveyData) {
                        this.$wait.start(this.loaderId);
                        try {
                            surveyData = await this.$store.dispatch(GET_SURVEY_ACTION, {
                                surveyId,
                                sectionId,
                            });
                        } catch (error) {
                            this.$wait.end(this.loaderId);
                            process.env.NODE_ENV !== 'production' && console.error(error);
                            this.$toasted.show('Some error occurs', {
                                type: 'error',
                                duration: 3000,
                            });
                        }
                    }
                    this.prior_survey = surveyData;
                    this.$wait.end(this.loaderId);
                }catch (error) {
                    if (!didAbort(error)) {
                        handleServerErrorWithValidation(error, this.$toasted);
                    }
                }
            }
        },
        priorQuestionnaireSections: function () {
            if (!this.prior_survey || !this.prior_survey.survey.questionnaire) return [];
            return this.prior_survey.survey.questionnaire.sections;
        },
        priorQuestionnaireQuestions: function () {
            const surveyQuestions = this.priorQuestionnaireSections().flatMap((s) =>
                Array.isArray(s.questionSections) &&
                (this.isModuleQuestionnaire || !s.is_module)
                    ? s.questionSections.map((qs) => qs.question)
                    : []
            );
            surveyQuestions.push(
                {
                    id: Date.now(),
                    type: QUESTION_TYPES.GEOGRAPHY_ICO_WRAPPER,
                    variables: [],
                    relatedJobQuestion: this.geographicJobQuestion,
                }
            );
            return surveyQuestions;
        },
        getPriorQuestionnaireJobQuestions: function () {
            let ques = this.priorQuestionnaireQuestions().filter(item => item.relatedJobQuestion !== null);
            return ques.reduce((result, {relatedJobQuestion}) => {
                if (relatedJobQuestion) {
                    result.push({...relatedJobQuestion});
                }
                return result;
            }, []);
        },
        setPriorQuestionnaire: function () {
            let notChangeQuestions = [];
            if (this.survey && this.$store.state.changeResponseQuestionIds) {
                this.survey.questionnaire.sections.forEach(section => {
                    if (section.questionSections) {
                    // Use filter to exclude questionSections with question_set_type 'Not Change'
                    section.questionSections = section.questionSections.filter(question => {
                        if (this.$store.state.priorQuestionIds && this.$store.state.changeResponseQuestionIds) {
                            //// set relatedJobQuestion null while questinnaire has prior year questionnaire /////
                        if (this.$store.state.priorQuestionIds.some(question_id => question_id === question.question_id)) {
                            question.question_set_type = 'Not Change';
                            //notChangeQuestions.push(question);
                        } else if (this.$store.state.changeResponseQuestionIds.some(question_id => question_id === question.question_id)) {
                            question.question_set_type = 'Change';
                            question.question.relatedJobQuestion = null;
                        } else {
                            question.question_set_type = 'New';
                        }
                        // Include the question if its question_set_type is not 'Not Change'
                        return question.question_set_type !== 'Not Change';
                        }
                        return true; // Include the question if conditions are not met
                    });
                    }
                });              
            }

            if (this.$store.state.setPriorSurvey && this.$store.state.changeResponseQuestionIds) {
                this.$store.state.setPriorSurvey.survey.questionnaire.sections.forEach(section => {
                    if (section.questionSections) {
                    // Use filter to exclude questionSections with question_set_type 'Not Change'
                    section.questionSections = section.questionSections.filter(question => {
                        if (this.$store.state.priorQuestionIds && this.$store.state.changeResponseQuestionIds) {
                        if (this.$store.state.priorQuestionIds.some(question_id => question_id === question.question_id)) {
                            question.question_set_type = 'Not Change';
                            notChangeQuestions.push(question);
                        } else if (this.$store.state.changeResponseQuestionIds.some(question_id => question_id === question.question_id)) {
                            question.question_set_type = 'Change';
                            //notChangeQuestions.push(question);
                        } else {
                            question.question_set_type = 'New';
                        }
                        // Include the question if its question_set_type is not 'Not Change'
                        return question.question_set_type !== 'Not Change';
                        }
                        return true; // Include the question if conditions are not met
                    });
                    }
                });                
            }
            // if(notChangeQuestions.length > 0)
            // {
            //     console.log(JSON.stringify(notChangeQuestions));
            //     this.savePriorQuestionnaireDefaultResponse(this.survey.id,notChangeQuestions);
            // }
        },
        // savePriorQuestionnaireDefaultResponse: async function (surveyId,notChangeQuestions = []) {
        //     try {
        //         await Api.savePriorQuestionnaireDefaultResponse(
        //             surveyId,
        //             notChangeQuestions
        //         );
        //         //await Api.updateUser(this, this.$store.state.user);
        //     } catch (error) {
        //         if (!didAbort(error)) {
        //             handleServerErrorWithValidation(error, this.$toasted);
        //         }
        //     }
        // },
        // getDesiredLocationDisplayName: function () {
        //     let location = null;
        //     if(this.geographicJobQuestion){
        //         location =  this.geographicJobQuestion.jobQuestionVariables[0].jobProfileQuestionResponses[0].value ? this.geographicJobQuestion.jobQuestionVariables[0].jobProfileQuestionResponses[0].value.display_name : '';
        //     }
        //     return location;
        // },
        getDefaultQuestionData: function () {
            if(this.$store.state.setPriorQuestions){
                this.getDefaultQuestionResponse = this.$store.state.setPriorQuestions;
            }
            return this.getDefaultQuestionResponse;
        },
        // loadDefaultSurveyData: function () {
        //     let defaultSurveyData = this.$store.state.loadDefaultSurveyData;
        //     if(defaultSurveyData){
        //         defaultSurveyData = defaultSurveyData.filter(item => item.question.relatedJobQuestion !== null);
        //             defaultSurveyData.forEach((question) => {
        //                 if(question.question.relatedJobQuestion != null)
        //                 {
        //                     let defaultLables = '';
        //                     question.question.relatedJobQuestion.jobQuestionVariables.forEach((jobQuestionVariable) => {
        //                         if(question.question.type == 'SLIDER'){
        //                             question.question.relatedJobQuestion.response_value = jobQuestionVariable.jobProfileQuestionResponses[0].value;
        //                             defaultLables += jobQuestionVariable.jobProfileQuestionResponses[0].value + '\n';
        //                         }else if(question.question.relatedJobQuestion.talent_type == 'YES_NO'){
        //                             defaultLables += (Math.floor(jobQuestionVariable.jobProfileQuestionResponses[0].value) == 1) ? jobQuestionVariable.input_label + '\n' : '';
        //                         }else{
        //                             question.question.relatedJobQuestion.response_value = jobQuestionVariable.jobProfileQuestionResponses[0].value ? jobQuestionVariable.input_label : '';
        //                             defaultLables += jobQuestionVariable.jobProfileQuestionResponses[0].value ? jobQuestionVariable.input_label + '\n' : '';
        //                         }
        //                         question.question.relatedJobQuestion.response_default_value = defaultLables;
        //                     });
        //                 }
        //                 /*else{
        //                     question.question.relatedJobQuestion.response_default_value = '';
        //                 }*/
        //         });
        //     }
        //     return defaultSurveyData;
        // },
        
        calculateIsSurveyComplete: function () {
            this.isCompleteClicked =
                this.questions.length > 0 &&
                incompletedQuestions(this.questions, this.variables).length === 0;
        },
        calculateCurrentQuestionIndex: function () {
            if(this.$store.state.setPriorSurvey && this.isFirstTime){
                this.currentQuestionIndex = 0;
                this.isFirstTime = false;
            }else{
                if (this.isModuleQuestionnaire) {
                    this.currentQuestionIndex = 0;
                } else if (this.survey.current_question_index < this.questions.length) {
                    this.currentQuestionIndex = this.survey.current_question_index;
                } else {
                    this.currentQuestionIndex =
                    this.questions.length > 0 ? this.questions.length - 1 : 0;
                }
            }
        },
        getNextApplicableQuestionIndex() {
            const currQuestionIndex = this.questions.indexOf(this.question);
            return this.questions.findIndex((q, index) => {
                return (
                    index > currQuestionIndex && isApplicableQuestion(q, this.variables)
                );
            });
        },
        getPreviousApplicableQuestionIndex() {
            return findLastIndex(this.questions, (q) => {
                return (
                    this.questions.indexOf(q) < this.questions.indexOf(this.question) &&
                    isApplicableQuestion(q, this.variables)
                );
            });
        },
        getSurveyCompleteRatio() {
            const completeSectionCount = this.sections.filter(
                (s) =>
                    getSectionCompletedOrDeclinedCount(
                        s,
                        this.variables,
                        this.survey.questionnaire.is_support_job_preference
                    ) === getSectionApplicableCount(s, this.variables)
            ).length;
            return completeSectionCount + '/' + this.sections.length;
        },
        updateSurvey: async function (submit = false) {
            this.survey.sections_completed = this.getSurveyCompleteRatio();
            const responses = this.getResponses();
            try {
                await Api.updateSurvey(
                    this,
                    {
                        ...this.survey,
                        responses: responses,
                    },
                    submit,
                    this.$route.params.sectionId || null
                );
                await Api.updateUser(this, this.$store.state.user);
            } catch (error) {
                if (!didAbort(error)) {
                    handleServerErrorWithValidation(error, this.$toasted);
                }
            }
        },
        goToPreviousQuestion: function (data) {
            const last = this.getPreviousApplicableQuestionIndex();
            if (last !== -1) {
                this.currentQuestionIndex = last;
                !this.isModuleQuestionnaire &&
                (this.survey.current_question_index = last);
            }
            this.$nextTick(() => {
                if (data==true) {
                    this.updateSurvey();
                }
            });
            //this.$nextTick(() => this.updateSurvey());
        },
        previousQuestion: function (data) {
            if (this.$v.$anyDirty) {
                this.getQuestionResponseAndUpdateData();
                this.resetQuestionFormValidation();
            }
            if (this.isSliderModalShouldBeOpened()) {
                this.isSliderNotAnsweredModalVisible = true;
                this.$options.afterSliderNotAnsweredIsClosed = () => {
                    this.goToPreviousQuestion(data);
                };
            } else if (!this.isCompleted(this.question)) {
                this.showRemindCoreQuestionModal = true;
                this.$options.afterCoreQuestionNotAnsweredIsClosed = () => {
                    this.goToPreviousQuestion(data);
                };
            } else {
                this.goToPreviousQuestion(data);
            }
        },
        onNextHandle: function (data) {
            if (this.$refs.icoStudyQuestion && !this.isIcoQuestionAnswered) {
                this.showRemindIcoQuestionModal = true
            } else {
                this.updateFormValues();
                if (this.isSliderModalShouldBeOpened()) {
                    this.isSliderNotAnsweredModalVisible = true;
                    this.$options.afterSliderNotAnsweredIsClosed = () => {
                        this.goToNextQuestion(data);
                    };
                } else if (!this.isCompleted(this.question)) {
                    this.showRemindCoreQuestionModal = true;
                    this.$options.afterCoreQuestionNotAnsweredIsClosed = () => {
                        this.goToNextQuestion(data);
                    };
                } else {
                    this.goToNextQuestion(data);
                }
            }
        },
        goToNextQuestion: function (data) {
            let next = this.getNextApplicableQuestionIndex();
            if (next !== -1) {
                this.currentQuestionIndex = next;
                !this.isModuleQuestionnaire &&
                (this.survey.current_question_index = next);
            }
            this.$nextTick(() => {
                if (data==true) {
                    this.updateSurvey();
                }
            });
            //this.$nextTick(() => this.updateSurvey());
        },
        completeStudyHandler: async function () {
            this.updateFormValues();
            if (this.isModuleQuestionnaire) this.updateSurvey(true);
            this.isSubmitModalVisible = true;
            this.completeSurveFlag = true;
            if(this.defaultJobProfile){
                if(this.defaultJobProfile.is_default == 1 && !this.$store.state.setPriorSurvey){
                    await Api.jobProfileCompleteStudy(
                        this.defaultJobProfile
                    );
                }
            }
        },
        reviewICOHandler: function () {
            this.isSubmitModalVisible = false;
            this.isReviewIcoModalVisible = true;
            this.updateSurvey(true);
            this.completeSurveFlag = true;
        },
        goToDashBoard: function () {
            this.isReviewIcoModalVisible = false; 
            this.onReviewICOSubmitSurvey();
            //// remove prior data storage /////
            this.removePriorStore();
            this.$router.push(`/user/dashboard`);
        },
        icoInEditMode: async function () {
            this.isReviewIcoModalVisible = false;
            this.completeSurveFlag = true;
            this.onReviewICOSubmitSurvey();
            //// remove prior data storage /////
            this.removePriorStore();
            
            const getDefaultProfile = await Api.getDefaultJobProfile(
                this.user.id
            );
            if(getDefaultProfile){
                this.$router.push(`/exchange/job-profile/${getDefaultProfile.id}`); 
            }else{
                this.$router.push(`/user/dashboard`); 
            }
        },
        createNewIcoMode: function () {
            this.isReviewIcoModalVisible = false;
            this.isNewIcoModalVisible = true;
        },
        onCancelNewJobProfile: function () {      
            this.isNewIcoModalVisible = false;   
            this.isReviewIcoModalVisible = true;  
        },
        onRenameJobProfile: async function (newTitle) {
            // eslint-disable-next-line no-unused-vars
            this.$wait.start('menu-loading');
            await Api.createDuplicateToDefaultJobProfile(
                this.defaultJobProfile,
                this.prior_year_questionnaire_id,
                newTitle
            );
            this.completeSurveFlag = true;
            await Api.updateUser(this, this.$store.state.user, true);
            //this.onReviewICOSubmitSurvey();
            //// remove prior data storage /////
            this.removePriorStore();
            this.isNewIcoModalVisible = false; 
            this.$wait.end('menu-loading');
            this.$router.push(`/user/dashboard`);
        },
        removePriorStore: function () {
            this.$store.state.priorQuestionIds = undefined;
            this.$store.state.changeResponseQuestionIds = undefined;
            this.$store.state.setPriorSurvey = undefined;
        },
        isInvalid: function (question) {
            return isInvalid(question);
        },
        isDeclined: function (question) {
            return isDeclined(question);
        },
        isCompleted: function (question) {
            return isCompleted(question);
        },
        isJobQuestionAnswered: function () {
            if (
                !this.question ||
                !this.question.relatedJobQuestion ||
                !this.$refs.icoStudyQuestion ||
                typeof this.$refs.icoStudyQuestion.isJobQuestionAnswered !== 'function'
            ) {
                return true;
            }
            return this.$refs.icoStudyQuestion.isJobQuestionAnswered();
        },
        saveResponses: function () {
            let responses = this.question.relatedJobQuestion.jobQuestionVariables.map(
                (v) => v.jobProfileQuestionResponses
            );
            responses = responses.flat();
            Api.updateJobProfileQuestionResponses(
                this.question.relatedJobQuestion.id,
                responses
            );
        },
        onUpdateJobProfile: async function (updatedProfile) {
            const profile = await this.$store.dispatch(
                UPDATE_JOB_PROFILE_ACTION,
                updatedProfile
            );

            this.defaultJobProfile = {
                ...this.defaultJobProfile,
                ...profile,
            };
            this.syncJobQuestionResponseData();

            this.$nextTick(() => {
                if (this.question.type === QUESTION_TYPES.GEOGRAPHY_ICO_WRAPPER) {
                    this.isCurrentQuestionComplete = this.isJobQuestionAnswered();
                }
            });
        },
        onSubmitSurvey: async function (formValidation=true) {
            this.$v.title.$touch();

            if(formValidation == true)
            {
                if (this.$v.title.$anyError) {
                    return;
                }
            }
            
            this.defaultJobProfile.title = this.title;
            this.submitLoading = true;
            try {
                await this.renameJobProfile();
                const {data: updatedSurvey} = await Api.updateSurvey(
                    this,
                    this.survey,
                    true
                );
                this.survey.submitted = updatedSurvey.submitted;
                await Api.updateUser(this, this.$store.state.user, true);
                if(this.defaultJobProfile){
                    if(this.defaultJobProfile.is_default == 1 && !this.$store.state.setPriorSurvey){
                        await Api.jobProfileCompleteStudy(
                            this.defaultJobProfile
                        );
                    }
                }
            } catch (error) {
                handleServerErrorWithValidation(error, this.$toasted);
            } finally {
                this.submitLoading = false;
            }
        },
        onReviewICOSubmitSurvey: async function () {
            try {
                await this.renameJobProfile();
                const {data: updatedSurvey} = await Api.updateSurvey(
                    this,
                    this.survey,
                    true
                );
                this.survey.submitted = updatedSurvey.submitted;
                await Api.updateUser(this, this.$store.state.user, true);
            } catch (error) {
                handleServerErrorWithValidation(error, this.$toasted);
            } finally {
                this.submitLoading = false;
            }
        },
        resetQuestionFormValidation: function () {
            return this.$v.$reset();
        },
        getQuestionResponseAndUpdateData: function () {
            if (
                this.$refs.questionForm &&
                typeof this.$refs.questionForm.getQuestionVariables === 'function'
            ) {
                let questionVariables = this.$refs.questionForm.getQuestionVariables();
                DerivedVariables.updateResponseValues(questionVariables);
                this.sections.forEach((section, sectionIndex) => {
                    section.questionSections.forEach((qs, qsIndex) => {
                        if (qs.question && qs.question.id === this.question.id)
                            this.$set(
                                this.survey.questionnaire.sections[sectionIndex]
                                    .questionSections[qsIndex].question,
                                'variables',
                                questionVariables
                            );
                    });
                });
                questionVariables.forEach((v) => {
                    const index = this.survey.responses.findIndex(
                        (r) => r.variable_id === v.id
                    );
                    this.$set(this.survey.responses, index, v.response);
                });
            }
        },
        syncJobQuestionResponseData: function () {
            if (
                this.$refs.icoStudyQuestion &&
                typeof this.$refs.icoStudyQuestion.getJobQuestionData === 'function'
            ) {
                const jobQuestion = this.$refs.icoStudyQuestion.getJobQuestionData();
                this.$set(this.question, 'relatedJobQuestion', jobQuestion);
            }
        },
        calculateIsJobQuestionVisible: function () {
            if (!this.$refs.isoStudyQuestion) {
                this.isJobQuestionFullyOnScreen = true;
            } else {
                const rect = this.$refs.isoStudyQuestion.getBoundingClientRect();
                this.isJobQuestionFullyOnScreen =
                    rect.bottom <=
                    (window.innerHeight || document.documentElement.clientHeight) - 100;
            }
        },
        goToQuestion: function (qId,questionCompleted) {
            this.updateFormValues();
            const index = this.questions.findIndex((q) => q.id === qId);
            if (index !== -1) {
                this.currentQuestionIndex = index;
                !this.isModuleQuestionnaire &&
                (this.survey.current_question_index = index);
                if(questionCompleted==true){
                    this.updateSurvey();
                }
            }
        },
        onSelectQuestion: function (data) {
            if (this.$refs.icoStudyQuestion && !this.isIcoQuestionAnswered) {
                this.showRemindIcoQuestionModal = true
            } else {
                this.updateFormValues();
                if (this.isSliderModalShouldBeOpened()) {
                    this.isSliderNotAnsweredModalVisible = true;
                    this.$options.afterSliderNotAnsweredIsClosed = () => {
                        this.goToQuestion(data.qId,data.questionCompleted);
                    };
                } else if (!this.isCompleted(this.question)) {
                    this.showRemindCoreQuestionModal = true;
                    this.$options.afterCoreQuestionNotAnsweredIsClosed = () => {
                        this.goToQuestion(data.qId,data.questionCompleted);
                    };
                } else {
                    this.goToQuestion(data.qId,data.questionCompleted);
                }
            }
        },
        onSelectJobQuestionInMyDesiredSection: function (jQId) {
            const index = this.questions.findIndex(
                (q) => q.relatedJobQuestion && q.relatedJobQuestion.id === jQId
            );
            if (index !== -1) {
                this.currentQuestionIndex = index;
                this.changeEditSectionLabel = true;
                !this.isModuleQuestionnaire &&
                (this.survey.current_question_index = index);
            }
        },
        renameJobProfile: async function () {
            // eslint-disable-next-line no-unused-vars
            const {jobQuestions, ...restProfileData} = this.defaultJobProfile || {};
            const profile = await this.$store.dispatch(UPDATE_JOB_PROFILE_ACTION, {
                ...restProfileData,
            });
            this.defaultJobProfile = {
                ...this.profile,
                ...profile,
            };
        },
        updateFormValues: function () {
            if (this.$v.$anyDirty) {
                this.getQuestionResponseAndUpdateData();
                if (this.question && this.question.relatedJobQuestion) {
                    this.syncJobQuestionResponseData();
                    this.question.type !== QUESTION_TYPES.GEOGRAPHY_ICO_WRAPPER &&
                    this.saveResponses();
                }
                this.resetQuestionFormValidation();
            }
        },
        getResponses: function () {
            const responses = [];
            this.questions.forEach((q) => {
                q.variables.forEach((v) => {
                    responses.push(v.response);
                });
            });
            return responses;
        },
        preventEventIfDirtyOrErrors: function (event) {
            if (!this.$v.$anyDirty) return;
            event.preventDefault();
            event.returnValue = '';
        },
        onAnswerQuestionLater: function () {
            if (typeof this.$options.afterSliderNotAnsweredIsClosed === 'function') {
                this.$options.afterSliderNotAnsweredIsClosed();
            }
            this.isSliderNotAnsweredModalVisible = false;
        },
        onAnswerCoreQuestionLater: function () {
            if (typeof this.$options.afterCoreQuestionNotAnsweredIsClosed === 'function') {
                this.$options.afterCoreQuestionNotAnsweredIsClosed();
            }
            this.showRemindCoreQuestionModal = false;
        },
        onResetSliderToMin: function (varIds) {
            if (this.question.type !== QUESTION_TYPES.SLIDER) return;
            this.sections.forEach((section, sectionIndex) => {
                section.questionSections.forEach((qs, qsIndex) => {
                    if (qs.question && qs.question.id === this.question.id)
                        qs.question.variables.forEach((v, vIndex) => {
                            const minValue = v.min ? v.min : 0;
                            if (varIds.includes(v.id) && isVariableHasNoResponse(v)) {
                                this.$set(
                                    this.survey.questionnaire.sections[sectionIndex]
                                        .questionSections[qsIndex].question.variables[vIndex]
                                        .response,
                                    'value',
                                    minValue
                                );
                                this.$set(
                                    this.survey.questionnaire.sections[sectionIndex]
                                        .questionSections[qsIndex].question.variables[vIndex]
                                        .response,
                                    'is_set_min',
                                    1
                                );
                                const index = this.survey.responses.findIndex((r) => {
                                    return r.variable_id === v.id;
                                });
                                this.$set(this.survey.responses[index], 'value', minValue);
                                this.$set(this.survey.responses[index], 'is_set_min', 1);
                            }
                        });
                });
            });
            this.onAnswerQuestionLater();
        },
        isSliderModalShouldBeOpened: function () {
            return (
                this.question.type === QUESTION_TYPES.SLIDER &&
                !this.isCompleted(this.question)
            );
        },
        onStudyQuestionUpdated: function () {
            this.$v.$touch();
            this.$nextTick(() => {
                this.getQuestionResponseAndUpdateData();
                this.$nextTick(() => {
                    this.isCurrentQuestionComplete = isCompleted(
                        this.question,
                        this.isQuestionnaireSupportJobPreference
                    );
                    this.isIcoQuestionAnswered = isIcoCompleted(this.question, this.isQuestionnaireSupportJobPreference);
                });
            });
        },
        onJobQuestionUpdated: function () {
            this.$v.$touch();
            this.syncJobQuestionResponseData();
            this.$nextTick(() => {
                this.isCurrentQuestionComplete = isCompleted(
                    this.question,
                    this.isQuestionnaireSupportJobPreference
                );
                this.isIcoQuestionAnswered = isIcoCompleted(this.question, this.isQuestionnaireSupportJobPreference);
            });
        },
        getJobQuestions: function () {
            return this.questions.reduce((result, {relatedJobQuestion}) => {
                if (relatedJobQuestion) {
                    result.push({...relatedJobQuestion});
                }
                return result;
            }, []);
        },
        handleSetCurrentQuestionIsComplete: function (isComplete) {
            this.$nextTick(() => {
                this.isCurrentQuestionComplete = isComplete;
                this.isIcoQuestionAnswered = isIcoCompleted(this.question, this.isQuestionnaireSupportJobPreference);
            });
        },
        addTotalTakenTimeToSurvey: async function (time) {
            await Api.addTotalTakenTimeToSurvey(this.survey.id, time);
        },
        initTakingStudyTimeCounter: function () {
            if (this.$options.takingStudyInterval !== null) {
                clearInterval(this.$options.takingStudyInterval);
            }
            this.$options.takingStudyInterval = setInterval(() => {
                const currTime = this.$dayjs();
                const millisFromLastActivity = currTime.diff(
                    this.$options.lastActivityTime
                );
                if (millisFromLastActivity < 5 * 60 * 1000) {
                    // less than 5 min
                    this.addTotalTakenTimeToSurvey(
                        this.$options.takingStudyIntervalValue
                    );
                }
            }, this.$options.takingStudyIntervalValue);
        },
        updateUserLastActivityTime: function () {
            this.$options.lastActivityTime = this.$dayjs();
        },
        getContent: async function () {
            try {
                this.content = await Api.getThankYouCompletingStudyMessage();
            } catch {
                this.$toasted.error(
                    'Unable to update page content. Please try again later',
                    {duration: 3000}
                );
            }
        },
        validateState: function (name) {
            const {$dirty, $error} = this.$v[name];
            return $dirty ? !$error : null;
        },
        scrollToICOQuestion: function () {
            this.showRemindIcoQuestionModal = false
            this.$refs["icoStudyQuestion"].$el.scrollIntoView({ block: "end" })
        }
    },
    watch: {
        question: function () {
            this.$nextTick(function () {
                window.scrollTo(0, 0);
                this.calculateIsJobQuestionVisible();
            });
        },
        currentJobQuestionId: function (newJqId, oldJqId) {
            if (!oldJqId && newJqId) {
                this.$nextTick(() => {
                    this.isCurrentQuestionComplete = this.isJobQuestionAnswered();
                });
            }
        },
        prior_year_questionnaire_id(newValue, oldValue) {
            if (newValue !== null) {
                console.log(oldValue);
                this.fetchPriorData();
            }
        }
    },
};
</script>

<!-- ----------------------------------------------------------------------- -->
<style scoped>
@media (min-width: 320px) and (max-width: 768px) {
    .study-form-container {
        padding: 10px;
    }
}

@media (min-width: 320px) and (max-width: 425px) {
    .display-on-phone {
        display: block !important;
    }

    .display-on-phone .btn {
        width: 100% !important;
        margin-left: unset !important;
        margin-top: 10px;
    }
}
.review-ico-btn{
    margin: 0 auto !important;
    display: flex !important;
    justify-content: center !important;
}
</style>
<style lang="scss">
// include this in any Vue component where you want to reference vars or mixins
@import '../../../../sass/variables_mixins';

.study-header {
  margin: 20px;
}

.section-progress {
  margin-left: 50px;
}

.study-form-container {
  border: 1px solid rgba(0, 88, 111, 0.2);
  padding: 30px;
}

.ico-title {
  color: #408293;
  margin-top: 15px;
  font-weight: bold;
}

.survey-form {
  flex: 1;
  background-color: #f7fafa;
  max-width: 1270px !important;
}

.job-profile-summary-header {
  i.mdi.mdi-pencil:hover {
    cursor: pointer;
  }
}

.survey-form__body {
  background: #f7fafa;
}

.tooltip-message {
  text-align: center;

  &__red {
    color: $phairify_color_red;
  }

  &__green {
    color: $phairify_color_green;
  }
}

.select-icon-wrapper {
  .mdi.mdi-pencil {
    color: $phairify_v2_color_primary_teal;
    font-size: 10px;
  }
}

.study-progress-bar {
  &:before {
    content: '\F072E';
    display: inline-block;
    font: normal normal normal 24px/1 'Material Design Icons';
    text-rendering: auto;
    line-height: inherit;
    -webkit-font-smoothing: antialiased;
    font-size: 60px;
    color: $phairify_color_darken_red;
    position: absolute;
    left: 50%;
    opacity: 0;
    transform: translateX(-50%);
    transition: opacity 0.7s;
    top: -80px;
  }

  &:after {
    content: 'See below';
    display: inline-block;
    text-rendering: auto;
    line-height: inherit;
    -webkit-font-smoothing: antialiased;
    font-size: 16px;
    color: $phairify_color_darken_red;
    position: absolute;
    left: 50%;
    opacity: 0;
    transform: translateX(-50%);
    transition: opacity 0.7s;
    top: -80px;
  }

  &.with-arrow:before,
  &.with-arrow:after {
    opacity: 100;
  }
}

.job-profile-summary-header {
  border: none;
}

.cancel-button {
  width: 120px !important;
  border: 1px solid #cb444a !important;
  border-radius: 0 !important;
  color: #cb444a !important;
  background-color: #ffffff !important;
}

.cancel-button:hover:not(.disabled) {
  background-color: #cb444a !important;
  color: #ffffff !important;
}

.submitted-survey-container {
  padding: 0 40px 15px 40px;
}

.button-container {
  margin-left: 28px;
}

.go-to-inform-connect-button {
  border-radius: 0;
  border: 1px solid $phairify_v2_color_primary_teal;
  height: 30px;
  line-height: 1px;
  color: $phairify_v2_color_primary_teal;
  background-color: #ffffff;
    width: 200px;
}

.go-to-inform-connect-button:hover:not(.disabled) {
  background-color: $phairify_v2_color_primary_teal;
  color: #ffffff;
}
.flex-flow-column{
    flex-flow: column;
}
</style>
